module.exports = __webpack_public_path__ + "img/ic_alert_triangle_red.a4f161b8.svg";